import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../../fields/button/button.module';
import { DateModule } from "../../fields/date/date.module";
import { TravellerFieldsetComponent } from "./traveller-fieldset.component";
import { DropdownFieldModule } from "../../fields/dropdown-field/dropdown-field.module";
import { PipesModule } from "libraries/pipes/pipes.module";
import { TextModule } from '../../fields/text/text.module';
import { IdentityInfoEditorModule } from "libraries/component/identity-info-editor/identity-info-editor.module";
import { TitleToGenderModule } from "libraries/pipes/title-to-gender/title-to-gender.module";
import { GetTravellerIndentityInfoDisplayModeModule } from './pipes/get-traveller-identity-info-display-mode.module';
import { TravellerFieldsetService } from './services/traveller-fieldset.service';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";

@NgModule({
    declarations: [
        TravellerFieldsetComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        DateModule,
        DropdownFieldModule,
        PipesModule,
        TextModule,
        IdentityInfoEditorModule,
        TitleToGenderModule,
        GetTravellerIndentityInfoDisplayModeModule,
        FontAwesomeModule,
        ComboboxFieldModule,
    ],
    exports: [
        TravellerFieldsetComponent,
    ],
    providers: [
        TravellerFieldsetService,
    ],
})
export class TravellerFieldsetModule {}
